import { ref } from 'vue'
import { defineStore } from 'pinia'
import { RequestService } from '../services/RequestService'
// Firebase SDK imports for Realtime Database access
import { getApp } from 'firebase/app'
import { getDatabase, ref as dbRef, child, get } from 'firebase/database'
import { isEmpty } from 'lodash'
const { handleErrors } = RequestService()

export const useFaqsStore = defineStore('faqs', () => {
  const faqs = ref({})
  const initialized = ref(false)

  async function initializeFaqs() {
    if (initialized.value && !isEmpty(faqs.value)) {
      return faqs.value
    }

    try {
      const db = getDatabase(getApp())
      const snapshot = await get(child(dbRef(db), 'FAQS'))

      if (snapshot.exists()) {
        faqs.value = snapshot.val()
      } else {
        faqs.value = {}
      }
      initialized.value = true
    } catch (error) {
      handleErrors('initializeFaqs', error)
      faqs.value = {}
    }
  }

  async function getFaqs() {
    if (!initialized.value) {
      await initializeFaqs()
    }
    return faqs
  }

  return {
    faqs,
    getFaqs,
    initialized
  }
})
